// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-placeholder {
  background-color: var(--surface-color);
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.dark .progress-placeholder {
  background-color: #374151;
  border-color: #4b5563;
}

.progress-placeholder-message {
  margin: 0;
  color: #3498db;
  font-size: 0.8rem;
  transition: color 0.3s ease;
}

.dark .progress-placeholder-message {
  color: #60a5fa;
}

.progress-placeholder--error {
  border-color: #ef4444;
}

.progress-placeholder-message--error {
  color: #ef4444;
}
`, "",{"version":3,"sources":["webpack://./src/components/report/ReportAnalysisStatusView.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".progress-placeholder {\n  background-color: var(--surface-color);\n  padding: 1rem;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n  transition: all 0.3s ease;\n}\n\n.dark .progress-placeholder {\n  background-color: #374151;\n  border-color: #4b5563;\n}\n\n.progress-placeholder-message {\n  margin: 0;\n  color: #3498db;\n  font-size: 0.8rem;\n  transition: color 0.3s ease;\n}\n\n.dark .progress-placeholder-message {\n  color: #60a5fa;\n}\n\n.progress-placeholder--error {\n  border-color: #ef4444;\n}\n\n.progress-placeholder-message--error {\n  color: #ef4444;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
